import { Projet } from '../types';

export const projetsInitiaux: Projet[] = [
  // ── Projet 1 : Résidence Les Lilas (terminé, dans les temps, sain) ──
  {
    id: 'p1',
    nom: 'Résidence Les Lilas',
    adresse: '12 avenue des Lilas, 69003 Lyon',
    client: 'SCI Les Lilas',
    dateDebut: '2024-03-01',
    dateFin: '2025-11-30',
    statut: 'termine',
    incidents: [],
    lots: [
      {
        id: 'p1-l1',
        nom: 'Gros Œuvre',
        entreprise: 'Bâtiment Plus SARL',
        montantSigne: 850000,
        coefficient: 1.20,
        dateDebutPrevue: '2024-03-01',
        dateFinPrevue: '2024-12-31',
        dateDebutReelle: '2024-03-15',
        dateFinReelle: '2024-12-20',
        statut: 'termine',
        situations: [
          { id: 's1', numero: 1, date: '2024-05-15', montantCumulatif: 170000, pourcentageAvancement: 20, commentaire: 'Fondations terminées' },
          { id: 's2', numero: 2, date: '2024-07-20', montantCumulatif: 382500, pourcentageAvancement: 45, commentaire: 'Élévation R+1' },
          { id: 's3', numero: 3, date: '2024-09-30', montantCumulatif: 637500, pourcentageAvancement: 75, commentaire: 'Élévation R+2 + plancher haut' },
          { id: 's3b', numero: 4, date: '2024-12-20', montantCumulatif: 850000, pourcentageAvancement: 100, commentaire: 'GO terminé' },
        ],
        travauxSupplementaires: [
          { id: 'ts1', intitule: 'Renforcement fondations zone nord', montant: 18500, lotId: 'p1-l1', dateAjout: '2024-04-10', statut: 'valide', commentaire: 'Sol argileux non prévu' },
        ],
      },
      {
        id: 'p1-l2',
        nom: 'Charpente / Couverture',
        entreprise: 'Toitures Rhône-Alpes',
        montantSigne: 320000,
        coefficient: 1.25,
        dateDebutPrevue: '2025-01-01',
        dateFinPrevue: '2025-04-30',
        dateDebutReelle: '2025-01-10',
        dateFinReelle: '2025-04-25',
        statut: 'termine',
        situations: [
          { id: 's1b1', numero: 1, date: '2025-02-28', montantCumulatif: 160000, pourcentageAvancement: 50 },
          { id: 's1b2', numero: 2, date: '2025-04-25', montantCumulatif: 320000, pourcentageAvancement: 100 },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p1-l3',
        nom: 'Électricité',
        entreprise: 'Élec Pro 69',
        montantSigne: 185000,
        coefficient: 1.30,
        dateDebutPrevue: '2025-03-01',
        dateFinPrevue: '2025-07-31',
        dateDebutReelle: '2025-03-05',
        dateFinReelle: '2025-07-20',
        statut: 'termine',
        situations: [
          { id: 's1c1', numero: 1, date: '2025-05-15', montantCumulatif: 111000, pourcentageAvancement: 60 },
          { id: 's1c2', numero: 2, date: '2025-07-20', montantCumulatif: 185000, pourcentageAvancement: 100 },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p1-l4',
        nom: 'Plomberie / CVC',
        entreprise: 'Thermo Confort',
        montantSigne: 245000,
        coefficient: 1.28,
        dateDebutPrevue: '2025-03-15',
        dateFinPrevue: '2025-08-31',
        dateDebutReelle: '2025-03-20',
        dateFinReelle: '2025-08-28',
        statut: 'termine',
        situations: [
          { id: 's1d1', numero: 1, date: '2025-06-15', montantCumulatif: 147000, pourcentageAvancement: 60 },
          { id: 's1d2', numero: 2, date: '2025-08-28', montantCumulatif: 245000, pourcentageAvancement: 100 },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p1-l5',
        nom: 'Menuiseries extérieures',
        entreprise: 'Alu Design',
        montantSigne: 142000,
        coefficient: 1.30,
        dateDebutPrevue: '2025-06-01',
        dateFinPrevue: '2025-09-30',
        dateDebutReelle: '2025-06-05',
        dateFinReelle: '2025-09-25',
        statut: 'termine',
        situations: [
          { id: 's1e1', numero: 1, date: '2025-08-15', montantCumulatif: 85200, pourcentageAvancement: 60 },
          { id: 's1e2', numero: 2, date: '2025-09-25', montantCumulatif: 142000, pourcentageAvancement: 100 },
        ],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 2 : Immeuble Bureau Horizon (à risque, léger retard + dépassement) ──
  {
    id: 'p2',
    nom: 'Immeuble Bureau Horizon',
    adresse: '45 rue de la République, 69001 Lyon',
    client: 'Foncière Horizon SAS',
    dateDebut: '2024-09-01',
    dateFin: '2026-06-30',
    statut: 'a_risque',
    incidents: [
      {
        id: 'inc-p2-1',
        projetId: 'p2',
        lotId: 'p2-l2',
        type: 'meteo',
        titre: 'Intempéries février 2026',
        description: 'Forte pluie et vent empêchant les travaux de façade pendant 2 semaines',
        dateDeclaration: '2026-02-05',
        statut: 'ouvert',
        impactFinancierEstime: 15000,
        impactDelaiEstime: 2,
      },
      {
        id: 'inc-p2-2',
        projetId: 'p2',
        lotId: 'p2-l1',
        type: 'technique',
        titre: 'Fissures dalle R+2',
        description: 'Micro-fissures détectées sur la dalle du R+2, expertise en cours',
        dateDeclaration: '2025-11-20',
        dateResolution: '2026-01-10',
        statut: 'resolu',
        impactFinancierEstime: 28000,
        impactDelaiEstime: 3,
      },
    ],
    lots: [
      {
        id: 'p2-l1',
        nom: 'Gros Œuvre',
        entreprise: 'Constructions Modernes',
        montantSigne: 1200000,
        coefficient: 1.18,
        dateDebutPrevue: '2024-09-01',
        dateFinPrevue: '2025-06-30',
        dateDebutReelle: '2024-09-15',
        dateFinReelle: '2025-07-15',
        statut: 'termine',
        avancementPhysiqueReel: 100,
        ventilationCouts: {
          debourseSecMain: 480000,
          debourseSecMateriaux: 420000,
          debourseSecMateriel: 120000,
          fraisGeneraux: 108000,
          fraisEncadrement: 72000,
        },
        sousTraitant: {
          referenceContrat: 'ST-P2L1-001',
          dateContrat: '2024-08-15',
          ordreDeService: 'OS-2024-089',
          dateOS: '2024-09-01',
          penalitesRetardJour: 500,
          penalitesCumulees: 7500,
          noteEvaluation: 3,
          commentaireEvaluation: 'Retard léger mais qualité correcte',
          situationsSousTraitant: [
            { id: 'sst-p2l1-1', numero: 1, date: '2025-01-15', montantDemande: 320000, montantAccepte: 310000, ecart: 10000 },
            { id: 'sst-p2l1-2', numero: 2, date: '2025-04-20', montantDemande: 700000, montantAccepte: 680000, ecart: 20000 },
            { id: 'sst-p2l1-3', numero: 3, date: '2025-07-15', montantDemande: 1200000, montantAccepte: 1160000, ecart: 40000 },
          ],
        },
        situations: [
          { id: 's4', numero: 1, date: '2024-12-15', montantCumulatif: 300000, pourcentageAvancement: 25 },
          { id: 's5', numero: 2, date: '2025-03-20', montantCumulatif: 660000, pourcentageAvancement: 55 },
          { id: 's6', numero: 3, date: '2025-06-15', montantCumulatif: 1020000, pourcentageAvancement: 85 },
          { id: 's7', numero: 4, date: '2025-07-15', montantCumulatif: 1200000, pourcentageAvancement: 100, commentaire: 'Réception GO' },
        ],
        travauxSupplementaires: [
          { id: 'ts2', intitule: 'Reprise étanchéité sous-sol', montant: 45000, lotId: 'p2-l1', dateAjout: '2025-02-20', statut: 'valide' },
          { id: 'ts3', intitule: 'Modification structure R+3', montant: 32000, lotId: 'p2-l1', dateAjout: '2025-05-10', statut: 'valide', commentaire: 'Demande architecte' },
        ],
      },
      {
        id: 'p2-l2',
        nom: 'Façades / Bardage',
        entreprise: 'Façade Concept',
        montantSigne: 580000,
        coefficient: 1.25,
        dateDebutPrevue: '2025-05-01',
        dateFinPrevue: '2025-12-31',
        dateDebutReelle: '2025-06-15',
        statut: 'en_retard',
        avancementPhysiqueReel: 55,
        ventilationCouts: {
          debourseSecMain: 174000,
          debourseSecMateriaux: 145000,
          debourseSecMateriel: 29000,
          fraisGeneraux: 34800,
          fraisEncadrement: 23200,
        },
        sousTraitant: {
          referenceContrat: 'ST-P2L2-001',
          dateContrat: '2025-04-20',
          ordreDeService: 'OS-2025-034',
          dateOS: '2025-05-01',
          penalitesRetardJour: 350,
          penalitesCumulees: 14000,
          noteEvaluation: 2,
          commentaireEvaluation: 'Retards récurrents, qualité à surveiller',
          situationsSousTraitant: [
            { id: 'sst-p2l2-1', numero: 1, date: '2025-09-30', montantDemande: 185000, montantAccepte: 174000, ecart: 11000 },
            { id: 'sst-p2l2-2', numero: 2, date: '2025-12-15', montantDemande: 365000, montantAccepte: 348000, ecart: 17000 },
          ],
        },
        situations: [
          { id: 's8', numero: 1, date: '2025-09-30', montantCumulatif: 174000, pourcentageAvancement: 30 },
          { id: 's9', numero: 2, date: '2025-12-15', montantCumulatif: 348000, pourcentageAvancement: 60, commentaire: 'Retard livraison panneaux' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p2-l3',
        nom: 'Lots techniques (Élec + CVC)',
        entreprise: 'Multi-Tech',
        montantSigne: 720000,
        coefficient: 1.27,
        dateDebutPrevue: '2025-09-01',
        dateFinPrevue: '2026-03-31',
        dateDebutReelle: '2025-09-15',
        statut: 'en_cours',
        situations: [
          { id: 's10', numero: 1, date: '2025-12-30', montantCumulatif: 216000, pourcentageAvancement: 30 },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p2-l4',
        nom: 'Aménagements intérieurs',
        entreprise: 'Intérieurs & Co',
        montantSigne: 430000,
        coefficient: 1.32,
        dateDebutPrevue: '2026-01-15',
        dateFinPrevue: '2026-06-30',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 3 : École Primaire Voltaire (en cours, dans les temps, sain) ──
  {
    id: 'p3',
    nom: 'École Primaire Voltaire',
    adresse: '8 place Voltaire, 69005 Lyon',
    client: 'Mairie de Lyon',
    dateDebut: '2025-06-01',
    dateFin: '2027-03-31',
    statut: 'en_cours',
    incidents: [],
    lots: [
      {
        id: 'p3-l1',
        nom: 'Gros Œuvre',
        entreprise: 'BTP Voltaire',
        montantSigne: 980000,
        coefficient: 1.20,
        dateDebutPrevue: '2025-06-01',
        dateFinPrevue: '2026-04-30',
        dateDebutReelle: '2025-06-10',
        statut: 'en_cours',
        situations: [
          { id: 's11', numero: 1, date: '2025-09-30', montantCumulatif: 245000, pourcentageAvancement: 25, commentaire: 'Fondations + début élévation' },
          { id: 's11b', numero: 2, date: '2026-01-15', montantCumulatif: 490000, pourcentageAvancement: 50, commentaire: 'Élévation R+1 en cours' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p3-l2',
        nom: 'Charpente Bois',
        entreprise: 'Bois & Structure',
        montantSigne: 420000,
        coefficient: 1.25,
        dateDebutPrevue: '2026-03-01',
        dateFinPrevue: '2026-07-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p3-l3',
        nom: 'Second Œuvre complet',
        entreprise: 'Aménagement Global',
        montantSigne: 650000,
        coefficient: 1.30,
        dateDebutPrevue: '2026-06-01',
        dateFinPrevue: '2027-01-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 4 : Centre Commercial Grand Ouest (terminé, léger TS) ──
  {
    id: 'p4',
    nom: 'Centre Commercial Grand Ouest',
    adresse: '120 boulevard de l\'Europe, 69008 Lyon',
    client: 'Immochan Développement',
    dateDebut: '2023-01-15',
    dateFin: '2024-09-30',
    statut: 'termine',
    incidents: [],
    lots: [
      {
        id: 'p4-l1',
        nom: 'Gros Œuvre',
        entreprise: 'Eiffage Construction',
        montantSigne: 2100000,
        coefficient: 1.18,
        dateDebutPrevue: '2023-01-15',
        dateFinPrevue: '2023-10-31',
        dateDebutReelle: '2023-02-01',
        dateFinReelle: '2023-11-15',
        statut: 'termine',
        situations: [
          { id: 's12', numero: 1, date: '2023-04-30', montantCumulatif: 525000, pourcentageAvancement: 25 },
          { id: 's13', numero: 2, date: '2023-07-15', montantCumulatif: 1155000, pourcentageAvancement: 55 },
          { id: 's14', numero: 3, date: '2023-09-30', montantCumulatif: 1785000, pourcentageAvancement: 85 },
          { id: 's15', numero: 4, date: '2023-11-15', montantCumulatif: 2100000, pourcentageAvancement: 100, commentaire: 'Réception GO validée' },
        ],
        travauxSupplementaires: [
          { id: 'ts4', intitule: 'Reprise fondation zone parking', montant: 35000, lotId: 'p4-l1', dateAjout: '2023-05-20', statut: 'valide' },
        ],
      },
      {
        id: 'p4-l2',
        nom: 'Façades vitrées',
        entreprise: 'Verre & Lumière',
        montantSigne: 890000,
        coefficient: 1.25,
        dateDebutPrevue: '2023-08-01',
        dateFinPrevue: '2024-02-28',
        dateDebutReelle: '2023-09-01',
        dateFinReelle: '2024-03-15',
        statut: 'termine',
        situations: [
          { id: 's16', numero: 1, date: '2023-11-30', montantCumulatif: 356000, pourcentageAvancement: 40 },
          { id: 's17', numero: 2, date: '2024-02-15', montantCumulatif: 712000, pourcentageAvancement: 80 },
          { id: 's18', numero: 3, date: '2024-03-15', montantCumulatif: 890000, pourcentageAvancement: 100 },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p4-l3',
        nom: 'Aménagements intérieurs',
        entreprise: 'Décor & Co',
        montantSigne: 1450000,
        coefficient: 1.35,
        dateDebutPrevue: '2024-01-15',
        dateFinPrevue: '2024-07-31',
        dateDebutReelle: '2024-02-01',
        dateFinReelle: '2024-08-20',
        statut: 'termine',
        situations: [
          { id: 's19', numero: 1, date: '2024-04-15', montantCumulatif: 507500, pourcentageAvancement: 35 },
          { id: 's20', numero: 2, date: '2024-06-30', montantCumulatif: 1087500, pourcentageAvancement: 75 },
          { id: 's21', numero: 3, date: '2024-08-20', montantCumulatif: 1450000, pourcentageAvancement: 100, commentaire: 'Livraison cellules commerciales' },
        ],
        travauxSupplementaires: [
          { id: 'ts5', intitule: 'Cloisonnement supplémentaire zone food-court', montant: 62000, lotId: 'p4-l3', dateAjout: '2024-03-10', statut: 'valide', commentaire: 'Demande locataire' },
        ],
      },
      {
        id: 'p4-l4',
        nom: 'Parking souterrain',
        entreprise: 'Parkings du Sud',
        montantSigne: 780000,
        coefficient: 1.22,
        dateDebutPrevue: '2024-03-01',
        dateFinPrevue: '2024-09-30',
        dateDebutReelle: '2024-03-15',
        dateFinReelle: '2024-09-25',
        statut: 'termine',
        situations: [
          { id: 's22', numero: 1, date: '2024-06-15', montantCumulatif: 390000, pourcentageAvancement: 50 },
          { id: 's23', numero: 2, date: '2024-09-25', montantCumulatif: 780000, pourcentageAvancement: 100 },
        ],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 5 : Résidence Seniors Les Glycines (en cours, avancé, dans les temps) ──
  {
    id: 'p5',
    nom: 'Résidence Seniors Les Glycines',
    adresse: '25 chemin des Glycines, 69300 Caluire',
    client: 'Groupe Korian',
    dateDebut: '2025-01-15',
    dateFin: '2026-10-31',
    statut: 'en_cours',
    incidents: [],
    lots: [
      {
        id: 'p5-l1',
        nom: 'Gros Œuvre',
        entreprise: 'Bouygues Bâtiment',
        montantSigne: 1350000,
        coefficient: 1.20,
        dateDebutPrevue: '2025-01-15',
        dateFinPrevue: '2025-10-31',
        dateDebutReelle: '2025-01-22',
        dateFinReelle: '2025-10-15',
        statut: 'termine',
        avancementPhysiqueReel: 100,
        ventilationCouts: {
          debourseSecMain: 540000,
          debourseSecMateriaux: 472500,
          debourseSecMateriel: 135000,
          fraisGeneraux: 121500,
          fraisEncadrement: 81000,
        },
        situations: [
          { id: 's24', numero: 1, date: '2025-04-15', montantCumulatif: 405000, pourcentageAvancement: 30 },
          { id: 's25', numero: 2, date: '2025-07-20', montantCumulatif: 945000, pourcentageAvancement: 70 },
          { id: 's26', numero: 3, date: '2025-10-15', montantCumulatif: 1350000, pourcentageAvancement: 100, commentaire: 'GO terminé - hors d\'eau hors d\'air' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p5-l2',
        nom: 'Menuiseries / Serrurerie',
        entreprise: 'Métal Concept',
        montantSigne: 380000,
        coefficient: 1.28,
        dateDebutPrevue: '2025-09-01',
        dateFinPrevue: '2026-02-28',
        dateDebutReelle: '2025-09-10',
        statut: 'en_cours',
        avancementPhysiqueReel: 45,
        ventilationCouts: {
          debourseSecMain: 95000,
          debourseSecMateriaux: 114000,
          debourseSecMateriel: 19000,
          fraisGeneraux: 22800,
          fraisEncadrement: 15200,
        },
        sousTraitant: {
          referenceContrat: 'ST-P5L2-001',
          dateContrat: '2025-08-20',
          ordreDeService: 'OS-2025-067',
          dateOS: '2025-09-01',
          penalitesRetardJour: 300,
          penalitesCumulees: 0,
          noteEvaluation: 4,
          commentaireEvaluation: 'Bon suivi, respect des délais',
          situationsSousTraitant: [
            { id: 'sst-p5l2-1', numero: 1, date: '2025-12-15', montantDemande: 195000, montantAccepte: 190000, ecart: 5000 },
          ],
        },
        situations: [
          { id: 's27', numero: 1, date: '2025-12-15', montantCumulatif: 190000, pourcentageAvancement: 50 },
        ],
        travauxSupplementaires: [
          { id: 'ts6', intitule: 'Garde-corps inox terrasses PMR', montant: 24000, lotId: 'p5-l2', dateAjout: '2025-10-05', statut: 'valide', commentaire: 'Mise en conformité accessibilité' },
        ],
      },
      {
        id: 'p5-l3',
        nom: 'CVC / Plomberie',
        entreprise: 'Dalkia Énergies',
        montantSigne: 520000,
        coefficient: 1.26,
        dateDebutPrevue: '2025-11-01',
        dateFinPrevue: '2026-05-31',
        dateDebutReelle: '2025-11-10',
        statut: 'en_cours',
        avancementPhysiqueReel: 22,
        ventilationCouts: {
          debourseSecMain: 65000,
          debourseSecMateriaux: 78000,
          debourseSecMateriel: 13000,
          fraisGeneraux: 15600,
          fraisEncadrement: 10400,
        },
        situations: [
          { id: 's28', numero: 1, date: '2026-01-20', montantCumulatif: 130000, pourcentageAvancement: 25, commentaire: 'Réseaux principaux en cours' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p5-l4',
        nom: 'Électricité / Courants faibles',
        entreprise: 'Spie Batignolles',
        montantSigne: 290000,
        coefficient: 1.30,
        dateDebutPrevue: '2025-11-15',
        dateFinPrevue: '2026-06-30',
        dateDebutReelle: '2025-11-20',
        statut: 'en_cours',
        situations: [
          { id: 's29', numero: 1, date: '2026-01-10', montantCumulatif: 58000, pourcentageAvancement: 20 },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p5-l5',
        nom: 'Aménagements intérieurs',
        entreprise: 'Agencement Prestige',
        montantSigne: 680000,
        coefficient: 1.33,
        dateDebutPrevue: '2026-04-01',
        dateFinPrevue: '2026-10-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 6 : Parking Silo Gare Part-Dieu (à risque, retard + dépassement = LE projet problématique) ──
  {
    id: 'p6',
    nom: 'Parking Silo Gare Part-Dieu',
    adresse: '2 place Charles Béraudier, 69003 Lyon',
    client: 'Lyon Parc Auto',
    dateDebut: '2025-02-01',
    dateFin: '2026-08-31',
    statut: 'a_risque',
    incidents: [
      {
        id: 'inc-p6-1',
        projetId: 'p6',
        lotId: 'p6-l1',
        type: 'environnemental',
        titre: 'Pollution sols hydrocarbures',
        description: 'Découverte de pollution aux hydrocarbures sur le secteur B, nécessitant une dépollution complète avant poursuite du terrassement',
        dateDeclaration: '2025-04-15',
        dateResolution: '2025-06-30',
        statut: 'resolu',
        impactFinancierEstime: 95000,
        impactDelaiEstime: 6,
      },
      {
        id: 'inc-p6-2',
        projetId: 'p6',
        lotId: 'p6-l1',
        type: 'technique',
        titre: 'Capacité portante insuffisante',
        description: 'Étude géotechnique complémentaire révèle une capacité portante inférieure aux hypothèses. Renforcement des pieux nécessaire.',
        dateDeclaration: '2025-05-10',
        statut: 'ouvert',
        impactFinancierEstime: 65000,
        impactDelaiEstime: 4,
      },
      {
        id: 'inc-p6-3',
        projetId: 'p6',
        type: 'securite',
        titre: 'Accident chute de hauteur',
        description: 'Chute d\'un ouvrier depuis un échafaudage (2m). Blessure légère mais arrêt chantier 48h pour inspection sécurité.',
        dateDeclaration: '2025-09-02',
        statut: 'ouvert',
        impactFinancierEstime: 8000,
        impactDelaiEstime: 1,
      },
    ],
    lots: [
      {
        id: 'p6-l1',
        nom: 'Gros Œuvre / Structure béton',
        entreprise: 'Demathieu Bard',
        montantSigne: 1800000,
        coefficient: 1.18,
        dateDebutPrevue: '2025-02-01',
        dateFinPrevue: '2025-12-31',
        dateDebutReelle: '2025-03-15',
        statut: 'en_retard',
        avancementPhysiqueReel: 40,
        ventilationCouts: {
          debourseSecMain: 360000,
          debourseSecMateriaux: 324000,
          debourseSecMateriel: 126000,
          fraisGeneraux: 97200,
          fraisEncadrement: 64800,
        },
        sousTraitant: {
          referenceContrat: 'ST-P6L1-001',
          dateContrat: '2025-01-20',
          ordreDeService: 'OS-2025-012',
          dateOS: '2025-02-01',
          penalitesRetardJour: 800,
          penalitesCumulees: 48000,
          noteEvaluation: 2,
          commentaireEvaluation: 'Retards importants, sous-effectif récurrent',
          situationsSousTraitant: [
            { id: 'sst-p6l1-1', numero: 1, date: '2025-06-15', montantDemande: 400000, montantAccepte: 360000, ecart: 40000 },
            { id: 'sst-p6l1-2', numero: 2, date: '2025-10-20', montantDemande: 880000, montantAccepte: 810000, ecart: 70000 },
          ],
        },
        situations: [
          { id: 's30', numero: 1, date: '2025-06-15', montantCumulatif: 360000, pourcentageAvancement: 20 },
          { id: 's31', numero: 2, date: '2025-10-20', montantCumulatif: 810000, pourcentageAvancement: 45, commentaire: 'Retard fondations - terrain pollué' },
        ],
        travauxSupplementaires: [
          { id: 'ts7', intitule: 'Dépollution terrain secteur B', montant: 95000, lotId: 'p6-l1', dateAjout: '2025-04-20', statut: 'valide', commentaire: 'Hydrocarbures découverts lors du terrassement' },
          { id: 'ts8', intitule: 'Renforcement pieux porteurs', montant: 42000, lotId: 'p6-l1', dateAjout: '2025-05-15', statut: 'valide' },
        ],
      },
      {
        id: 'p6-l2',
        nom: 'Étanchéité / Revêtement sol',
        entreprise: 'Soprema Solutions',
        montantSigne: 340000,
        coefficient: 1.25,
        dateDebutPrevue: '2025-11-01',
        dateFinPrevue: '2026-03-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p6-l3',
        nom: 'Équipements techniques (ventilation, élec, CCTV)',
        entreprise: 'Equans',
        montantSigne: 620000,
        coefficient: 1.28,
        dateDebutPrevue: '2026-02-01',
        dateFinPrevue: '2026-06-30',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p6-l4',
        nom: 'Signalétique / Peinture',
        entreprise: 'Signalisation France',
        montantSigne: 180000,
        coefficient: 1.35,
        dateDebutPrevue: '2026-05-01',
        dateFinPrevue: '2026-08-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 7 : Hôtel Boutique Confluence (en pause, léger TS) ──
  {
    id: 'p7',
    nom: 'Hôtel Boutique Confluence',
    adresse: '58 quai Rambaud, 69002 Lyon',
    client: 'Accor Invest',
    dateDebut: '2025-03-01',
    dateFin: '2027-03-31',
    statut: 'en_pause',
    incidents: [
      {
        id: 'inc-p7-1',
        projetId: 'p7',
        type: 'administratif',
        titre: 'Permis modificatif en attente',
        description: 'Modification du permis de construire nécessaire suite au changement de destination des niveaux R+4 et R+5. Délai instruction 3 mois.',
        dateDeclaration: '2025-12-01',
        statut: 'ouvert',
        impactFinancierEstime: 0,
        impactDelaiEstime: 12,
      },
    ],
    lots: [
      {
        id: 'p7-l1',
        nom: 'Démolition / Curage',
        entreprise: 'Cardem',
        montantSigne: 280000,
        coefficient: 1.15,
        dateDebutPrevue: '2025-03-01',
        dateFinPrevue: '2025-05-31',
        dateDebutReelle: '2025-03-15',
        dateFinReelle: '2025-06-10',
        statut: 'termine',
        sousTraitant: {
          referenceContrat: 'ST-P7L1-001',
          dateContrat: '2025-02-15',
          ordreDeService: 'OS-2025-019',
          dateOS: '2025-03-01',
          penalitesRetardJour: 200,
          penalitesCumulees: 2000,
          noteEvaluation: 4,
          commentaireEvaluation: 'Travail soigné, léger retard mineur',
          situationsSousTraitant: [
            { id: 'sst-p7l1-1', numero: 1, date: '2025-04-30', montantDemande: 172000, montantAccepte: 168000, ecart: 4000 },
            { id: 'sst-p7l1-2', numero: 2, date: '2025-06-10', montantDemande: 285000, montantAccepte: 280000, ecart: 5000 },
          ],
        },
        situations: [
          { id: 's32', numero: 1, date: '2025-04-30', montantCumulatif: 168000, pourcentageAvancement: 60 },
          { id: 's33', numero: 2, date: '2025-06-10', montantCumulatif: 280000, pourcentageAvancement: 100, commentaire: 'Curage complet terminé' },
        ],
        travauxSupplementaires: [
          { id: 'ts9', intitule: 'Désamiantage complémentaire faux-plafonds', montant: 38000, lotId: 'p7-l1', dateAjout: '2025-04-10', statut: 'valide', commentaire: 'Diagnostic amiante positif zone 3' },
        ],
      },
      {
        id: 'p7-l2',
        nom: 'Gros Œuvre / Restructuration',
        entreprise: 'Vinci Construction',
        montantSigne: 1650000,
        coefficient: 1.20,
        dateDebutPrevue: '2025-06-01',
        dateFinPrevue: '2026-04-30',
        dateDebutReelle: '2025-06-20',
        statut: 'en_cours',
        situations: [
          { id: 's34', numero: 1, date: '2025-10-15', montantCumulatif: 330000, pourcentageAvancement: 20, commentaire: 'Reprise structurelle niveaux bas - chantier en pause depuis décembre' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p7-l3',
        nom: 'Second Œuvre / Finitions hôtelières',
        entreprise: 'Hôtel Concept Design',
        montantSigne: 920000,
        coefficient: 1.35,
        dateDebutPrevue: '2026-03-01',
        dateFinPrevue: '2026-11-30',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p7-l4',
        nom: 'CVC / Plomberie / Élec',
        entreprise: 'Engie Solutions',
        montantSigne: 730000,
        coefficient: 1.27,
        dateDebutPrevue: '2026-04-01',
        dateFinPrevue: '2027-01-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p7-l5',
        nom: 'Ascenseurs',
        entreprise: 'Otis France',
        montantSigne: 195000,
        coefficient: 1.22,
        dateDebutPrevue: '2026-08-01',
        dateFinPrevue: '2027-02-28',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 8 : Gymnase Municipal Gerland (en cours, début, dans les temps) ──
  {
    id: 'p8',
    nom: 'Gymnase Municipal Gerland',
    adresse: '85 allée Pierre de Coubertin, 69007 Lyon',
    client: 'Métropole de Lyon',
    dateDebut: '2025-09-01',
    dateFin: '2027-04-30',
    statut: 'en_cours',
    incidents: [],
    lots: [
      {
        id: 'p8-l1',
        nom: 'Terrassement / VRD',
        entreprise: 'Colas Rhône-Alpes',
        montantSigne: 350000,
        coefficient: 1.18,
        dateDebutPrevue: '2025-09-01',
        dateFinPrevue: '2026-01-31',
        dateDebutReelle: '2025-09-10',
        dateFinReelle: '2026-01-20',
        statut: 'termine',
        situations: [
          { id: 's35', numero: 1, date: '2025-11-15', montantCumulatif: 175000, pourcentageAvancement: 50, commentaire: 'Terrassement terminé, réseaux en cours' },
          { id: 's35b', numero: 2, date: '2026-01-20', montantCumulatif: 350000, pourcentageAvancement: 100, commentaire: 'VRD terminés' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p8-l2',
        nom: 'Gros Œuvre / Charpente métallique',
        entreprise: 'Baudin Chateauneuf',
        montantSigne: 1580000,
        coefficient: 1.20,
        dateDebutPrevue: '2026-01-15',
        dateFinPrevue: '2026-10-31',
        dateDebutReelle: '2026-01-20',
        statut: 'en_cours',
        avancementPhysiqueReel: 4,
        ventilationCouts: {
          debourseSecMain: 31600,
          debourseSecMateriaux: 28440,
          debourseSecMateriel: 7900,
          fraisGeneraux: 7110,
          fraisEncadrement: 3950,
        },
        sousTraitant: {
          referenceContrat: 'ST-P8L2-001',
          dateContrat: '2025-12-20',
          ordreDeService: 'OS-2026-003',
          dateOS: '2026-01-15',
          penalitesRetardJour: 600,
          penalitesCumulees: 0,
          noteEvaluation: 5,
          commentaireEvaluation: 'Excellent démarrage, équipe qualifiée',
          situationsSousTraitant: [
            { id: 'sst-p8l2-1', numero: 1, date: '2026-02-01', montantDemande: 82000, montantAccepte: 79000, ecart: 3000 },
          ],
        },
        situations: [
          { id: 's35c', numero: 1, date: '2026-02-01', montantCumulatif: 79000, pourcentageAvancement: 5, commentaire: 'Démarrage fondations' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p8-l3',
        nom: 'Couverture / Bardage',
        entreprise: 'Smac Rhône',
        montantSigne: 480000,
        coefficient: 1.25,
        dateDebutPrevue: '2026-08-01',
        dateFinPrevue: '2027-01-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p8-l4',
        nom: 'Sol sportif / Aménagements intérieurs',
        entreprise: 'Sport Équipements',
        montantSigne: 410000,
        coefficient: 1.32,
        dateDebutPrevue: '2026-11-01',
        dateFinPrevue: '2027-03-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p8-l5',
        nom: 'Lots techniques (Élec + CVC)',
        entreprise: 'Dalkia Énergies',
        montantSigne: 560000,
        coefficient: 1.28,
        dateDebutPrevue: '2026-09-01',
        dateFinPrevue: '2027-03-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
    ],
  },

  // ── Projet 9 : Crèche Les Petits Explorateurs (en cours, sous budget, dans les temps) ──
  {
    id: 'p9',
    nom: 'Crèche Les Petits Explorateurs',
    adresse: '14 rue Pasteur, 69006 Lyon',
    client: 'Mairie de Lyon - Petite Enfance',
    dateDebut: '2025-05-01',
    dateFin: '2026-09-30',
    statut: 'en_cours',
    incidents: [],
    lots: [
      {
        id: 'p9-l1',
        nom: 'Gros Œuvre',
        entreprise: 'Batiroc Construction',
        montantSigne: 620000,
        coefficient: 1.20,
        dateDebutPrevue: '2025-05-01',
        dateFinPrevue: '2025-12-15',
        dateDebutReelle: '2025-05-05',
        dateFinReelle: '2025-11-28',
        statut: 'termine',
        avancementPhysiqueReel: 100,
        ventilationCouts: {
          debourseSecMain: 248000,
          debourseSecMateriaux: 217000,
          debourseSecMateriel: 62000,
          fraisGeneraux: 55800,
          fraisEncadrement: 37200,
        },
        sousTraitant: {
          referenceContrat: 'ST-P9L1-001',
          dateContrat: '2025-04-15',
          ordreDeService: 'OS-2025-041',
          dateOS: '2025-05-01',
          penalitesRetardJour: 400,
          penalitesCumulees: 0,
          noteEvaluation: 5,
          commentaireEvaluation: 'Excellent, terminé en avance',
          situationsSousTraitant: [
            { id: 'sst-p9l1-1', numero: 1, date: '2025-07-15', montantDemande: 190000, montantAccepte: 186000, ecart: 4000 },
            { id: 'sst-p9l1-2', numero: 2, date: '2025-09-20', montantDemande: 410000, montantAccepte: 403000, ecart: 7000 },
            { id: 'sst-p9l1-3', numero: 3, date: '2025-11-28', montantDemande: 625000, montantAccepte: 620000, ecart: 5000 },
          ],
        },
        situations: [
          { id: 's36', numero: 1, date: '2025-07-15', montantCumulatif: 186000, pourcentageAvancement: 30 },
          { id: 's37', numero: 2, date: '2025-09-20', montantCumulatif: 403000, pourcentageAvancement: 65 },
          { id: 's38', numero: 3, date: '2025-11-28', montantCumulatif: 620000, pourcentageAvancement: 100, commentaire: 'GO terminé en avance - aucun imprévu' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p9-l2',
        nom: 'Charpente / Couverture bois',
        entreprise: 'Bois Éco-Construction',
        montantSigne: 285000,
        coefficient: 1.25,
        dateDebutPrevue: '2025-11-01',
        dateFinPrevue: '2026-02-28',
        dateDebutReelle: '2025-11-05',
        statut: 'en_cours',
        avancementPhysiqueReel: 70,
        ventilationCouts: {
          debourseSecMain: 85500,
          debourseSecMateriaux: 99750,
          debourseSecMateriel: 14250,
          fraisGeneraux: 17100,
          fraisEncadrement: 11400,
        },
        sousTraitant: {
          referenceContrat: 'ST-P9L2-001',
          dateContrat: '2025-10-20',
          ordreDeService: 'OS-2025-089',
          dateOS: '2025-11-01',
          penalitesRetardJour: 250,
          penalitesCumulees: 0,
          noteEvaluation: 4,
          commentaireEvaluation: 'Bonne progression, qualité bois excellente',
          situationsSousTraitant: [
            { id: 'sst-p9l2-1', numero: 1, date: '2025-12-20', montantDemande: 118000, montantAccepte: 114000, ecart: 4000 },
            { id: 'sst-p9l2-2', numero: 2, date: '2026-01-30', montantDemande: 218000, montantAccepte: 213750, ecart: 4250 },
          ],
        },
        situations: [
          { id: 's39', numero: 1, date: '2025-12-20', montantCumulatif: 114000, pourcentageAvancement: 40 },
          { id: 's40', numero: 2, date: '2026-01-30', montantCumulatif: 213750, pourcentageAvancement: 75, commentaire: 'Charpente bois en bonne voie' },
        ],
        travauxSupplementaires: [],
      },
      {
        id: 'p9-l3',
        nom: 'Second Œuvre / Aménagements',
        entreprise: 'Espace Enfance Design',
        montantSigne: 410000,
        coefficient: 1.30,
        dateDebutPrevue: '2026-02-15',
        dateFinPrevue: '2026-07-31',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p9-l4',
        nom: 'Lots techniques (Élec + CVC)',
        entreprise: 'Électra Lyon',
        montantSigne: 195000,
        coefficient: 1.28,
        dateDebutPrevue: '2026-03-01',
        dateFinPrevue: '2026-06-30',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
      {
        id: 'p9-l5',
        nom: 'Espaces extérieurs / Jeux',
        entreprise: 'Proludic',
        montantSigne: 145000,
        coefficient: 1.30,
        dateDebutPrevue: '2026-06-01',
        dateFinPrevue: '2026-09-30',
        statut: 'non_demarre',
        situations: [],
        travauxSupplementaires: [],
      },
    ],
  },
];
